// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState, Update} from '@ngrx/entity';
// Actions
import {PickingActions, PickingActionTypes} from '../_actions/picking.actions';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
import {Picking} from '..';

// Models

export interface PickingState extends EntityState<Picking> {
	listLoading: boolean;
	actionsloading: boolean;
	totalCount: number;
	lastQuery: QueryParamsModel;
	lastCreatedPickingId: number;
	showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Picking> = createEntityAdapter<Picking>();

export const initialPickingState: PickingState = adapter.getInitialState({
	listLoading: false,
	actionsloading: false,
	totalCount: 0,
	lastQuery: new QueryParamsModel({}),
	lastCreatedPickingId: undefined,
	showInitWaitingMessage: true
});

export function pickingReducer(state = initialPickingState, action: PickingActions): PickingState {
	switch (action.type) {
		case PickingActionTypes.PickingPageToggleLoading:
			return {
				...state, listLoading: action.payload.isLoading, lastCreatedPickingId: undefined
			};
		case PickingActionTypes.PickingActionToggleLoading:
			return {
				...state, actionsloading: action.payload.isLoading
			};
		case PickingActionTypes.PickingOnServerCreated:
			return {
				...state
			};
		// case PickingActionTypes.PickingCreated:
		// 	return adapter.addOne(action.payload.Picking, {
		// 		...state, lastCreatedPickingId: action.payload.product.id
		// 	});
		case PickingActionTypes.PickingUpdated:
			return adapter.updateOne(action.payload.partialPicking, state);
		// case PickingActionTypes.PickingStatusUpdated: {
		// 	const _partialPicking: Update<Picking>[] = [];
		// 	for (let i = 0; i < action.payload.Picking.length; i++) {
		// 		_partialPicking.push({
		// 			id: action.payload.Picking[i].id,
		// 			changes: {
		// 				status: action.payload.status
		// 			}
		// 		});
		// 	}
		// 	return adapter.updateMany(_partialPicking, state);
		// }
		case PickingActionTypes.OnePickingDeleted:
			return adapter.removeOne(action.payload.id, state);
		case PickingActionTypes.ManyPickingDeleted:
			return adapter.removeMany(action.payload.ids, state);
		case PickingActionTypes.PickingPageCancelled:
			return {
				...state, listLoading: false, lastQuery: new QueryParamsModel({})
			};
		case PickingActionTypes.PickingPageLoaded:
			return adapter.addMany(action.payload.Picking, {
				...initialPickingState,
				totalCount: action.payload.totalCount,
				listLoading: false,
				lastQuery: action.payload.page,
				showInitWaitingMessage: false
			});
		default:
			return state;
	}
}

export const getPickingtate = createFeatureSelector<Picking>('picking');

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = adapter.getSelectors();
